module.exports = __webpack_public_path__ + "img/70029.efa77cf3.png";